import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nContext";
import { useSite } from "@/context/SiteContext";
import { estimate, useFeeModel } from "@/lib/fees";

const Line = ({ label, value, strong, testId }) => (
  <div className={`flex min-w-0 flex-wrap items-baseline justify-between gap-x-2 ${strong ? "font-bold text-emerald-200" : "text-neutral-300"}`} data-testid={testId}>
    <span className="min-w-0 break-words">{label}</span>
    <span className="shrink-0 tabular-nums">{value}</span>
  </div>
);

// Admin only: Payé TTC → TVA → frais Stripe → net estimé, live from the auto-updated fee model.
export const NetBreakdown = ({ ht, currency = "eur", testId = "net-breakdown", className = "" }) => {
  const { user } = useAuth();
  const { t, locale } = useI18n();
  const { usd } = useSite();
  const m = useFeeModel(Boolean(user));
  if (!user || !m || !(ht > 0)) return null;
  const e = estimate(m.rates, ht, currency, usd?.rate || 1);
  const f = (v) => new Intl.NumberFormat(locale, { style: "currency", currency: currency.toUpperCase() }).format(v);
  return (
    <div className={`min-w-0 space-y-0.5 rounded-xl border border-emerald-500/30 bg-emerald-950/20 p-2.5 text-[0.72rem] ${className}`} data-testid={testId}>
      <Line label={t("fees.paid")} value={f(e.ttc)} testId={`${testId}-ttc`} />
      <Line label={`− ${t("fees.vat")}`} value={f(e.vat)} testId={`${testId}-vat`} />
      <Line label={`− ${t("fees.card")}`} value={f(e.card)} testId={`${testId}-card`} />
      <Line label={`− ${t("fees.managed")} + ${t("fees.billing")}`} value={f(e.managed + e.billing)} testId={`${testId}-separate`} />
      <Line label={t("fees.net")} value={f(e.net)} strong testId={`${testId}-net`} />
    </div>
  );
};
